import * as React from 'react'
import {indexedMap} from '../../../Data/ArrayHelper'
import * as Nullable from '../../../Data/Nullable'
import {ProductAdd, Step2State} from './Step2State'
import {Step2SubAction} from './Step2Actions'
import Card from 'material-ui/Card/Card'
import TextField from 'material-ui/TextField'
import TableHeader from 'material-ui/Table/TableHeader'
import Table from 'material-ui/Table/Table'
import TableRow from 'material-ui/Table/TableRow'
import TableHeaderColumn from 'material-ui/Table/TableHeaderColumn'
import TableBody from 'material-ui/Table/TableBody'
import TableRowColumn from 'material-ui/Table/TableRowColumn'
import IconButton from 'material-ui/IconButton'
import ContentRemoveCircle from 'material-ui/svg-icons/content/remove-circle'
import {Product} from '../../../Entities/Product'
import RaisedButton from 'material-ui/RaisedButton'
import {
    renderSuggestion, renderSuggestionsContainer,
    shouldRenderSuggestions
} from '../../../View/MaterialAutosuggest'
import * as Autosuggest from 'react-autosuggest'
import TextFieldProps = __MaterialUI.TextFieldProps
import {card, singleColors} from '../../../Style'
import injectSheet from 'react-jss'

const styles = {
    root: {
        display: 'flex',
        justifyContent: 'center'
    },
    collectedInput: {
        display: 'flex',
        flexDirection: 'row'

    },
    ...card
}

interface Props {
    readonly state: Step2State,
    readonly dispatch: (action: Step2SubAction) => void,

}

export const Step2View =
    injectSheet<Props>(styles)(
        ({classes, state, dispatch}) => (
            <div className={classes.root}>
                <Card
                    className={classes.card}
                    style={{
                        maxWidth: '1536px'
                    }}
                >
                    <div className={classes.cardRow}>
                        <div className={classes.cardColumn}>
                            <h2 className={classes.cardHeader}>Produkt hinzufügen</h2>
                            <form
                                className={classes.cardContent}
                                onSubmit={event => {
                                    event.preventDefault()
                                    dispatch({type: 'ProductAddSubmit'})
                                }}
                            >
                                <div className={classes.collectedInput}>
                                    <ProductListView productAdd={state.productAdd} dispatch={dispatch}/>

                                    <TextField
                                        floatingLabelText="Menge"
                                        type="number"
                                        step={1}
                                        min={1}
                                        value={state.productAdd.input.amount}
                                        onChange={
                                            (event, value: string) => dispatch({
                                                type: 'ProductAddAmountChanged',
                                                value,
                                            })}
                                        errorText={
                                            state.productAdd.validation.amount === 'Mandatory' ?
                                                'Menge ist ein Pflichtfeld' :
                                                state.productAdd.validation.amount === 'InvalidInt' ?
                                                    'Menge muss eine ganze Zahl sein' :
                                                    null}
                                    />
                                </div>
                                <RaisedButton
                                    label="Hinzufügen"
                                    type="submit"
                                    primary={true}
                                    style={{marginTop: '40px'}}
                                />

                                <h2 className={classes.cardHeader}>
                                    Ausgewählte Produkte
                                </h2>
                                {state.validation.positions === 'EmptyArray' &&
                                <p style={{color: 'red'}}>
                                    Mindestens eine Position muss hinzugefügt werden
                                </p>}
                                <Table selectable={false} fixedHeader={false}>
                                    <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                                        <TableRow>
                                            <TableHeaderColumn>Produkt</TableHeaderColumn>
                                            <TableHeaderColumn>Menge</TableHeaderColumn>
                                            <TableHeaderColumn style={{width: '60px'}}/>
                                        </TableRow>
                                    </TableHeader>
                                    <TableBody displayRowCheckbox={false}>
                                        {indexedMap(
                                            (index, position) =>
                                                <TableRow key={position.product.productId}>
                                                    <TableRowColumn>
                                                        {position.product.name}
                                                    </TableRowColumn>
                                                    <TableRowColumn>
                                                        {position.amount}
                                                    </TableRowColumn>
                                                    <TableRowColumn>
                                                        <IconButton
                                                            onClick={
                                                                () => dispatch({
                                                                    type: 'DeletePosition',
                                                                    index,
                                                                })
                                                            }
                                                            style={{marginLeft: '10px'}}
                                                        >
                                                            <ContentRemoveCircle
                                                                color={singleColors.errorColor}
                                                            />
                                                        </IconButton>
                                                    </TableRowColumn>
                                                </TableRow>,
                                            state.input.positions)}
                                    </TableBody>
                                </Table>
                            </form>
                        </div>
                    </div>
                </Card>
            </div>)
    )

const stylesProductList = {
    root: {
        width: '50%',
        marginRight: '20px'

    }
}

interface PropsProductList {
    readonly productAdd: ProductAdd,
    readonly dispatch: (action: Step2SubAction) => void,
}

export const ProductListView =
    injectSheet<PropsProductList>(stylesProductList)(
        ({classes, productAdd, dispatch}) => (
            <div className={classes.root}>
                <Autosuggest
                    suggestions={productAdd.productSuggestions}
                    onSuggestionsFetchRequested={
                        (value: string) => dispatch({
                            type: 'ProductAddFetchProductSuggestions',
                            value,
                        })}
                    onSuggestionsClearRequested={
                        () => dispatch({
                            type: 'ProductAddClearProductSuggestions',
                        })}
                    getSuggestionValue={
                        (nullableProduct: Product | null) =>
                            Nullable.map(
                                product => product.name,
                                nullableProduct)}
                    inputProps={{
                        value: productAdd.productSearch,
                        // tslint:disable-next-line
                        onChange: (event: any, {newValue}: { newValue: string }) => dispatch({
                            type: 'ProductAddProductSearchChanged',
                            value: newValue,
                        }),
                    }}
                    onSuggestionSelected={
                        // tslint:disable-next-line
                        (event: any, {suggestion}: { suggestion: Product }) => dispatch({
                            type: 'ProductAddProductChanged',
                            value: suggestion,
                        })}
                    renderInputComponent={
                        (inputProps: TextFieldProps) =>
                            <TextField
                                {...inputProps}
                                floatingLabelText="Produkt"
                                errorText={
                                    productAdd.validation.product === 'Mandatory' ?
                                        'Produkt ist ein Pflichtfeld' :
                                        null}
                                fullWidth={true}
                            />
                    }
                    renderSuggestionsContainer={renderSuggestionsContainer}
                    renderSuggestion={
                        renderSuggestion(
                            (suggestion: Product) => suggestion.name)}
                    shouldRenderSuggestions={shouldRenderSuggestions}
                />
            </div>
        )
    )



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/OrderCreate/Step2/Step2View.tsx